module.exports = __webpack_public_path__ + "static/media/A35.db483cc5.png";